export const PRIMARY = '#7ac143'
export const PRIMARY_DARK = '#5e9a31'
export const PRIMARY_SHADOW = 'rgba(122,193,67,0.45)'
export const SECONDARY = '#727272'

export const S = {
  bubble: {
    position: 'fixed',
    bottom: 4,
    right: 4,
    width: 68,
    height: 68,
    borderRadius: 0,
    overflow: 'visible',
    background: 'transparent',
    boxShadow: 'none',
    border: 'none',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    cursor: 'pointer',
    zIndex: 9999,
    color: PRIMARY,
    fontSize: 20,
    fontWeight: 700,
    transition: 'box-shadow 0.18s, transform 0.18s',
  },
  panel: {
    position: 'fixed',
    bottom: 112,
    right: 24,
    width: 380,
    maxHeight: 'min(680px, calc(100vh - 170px))',
    maxWidth: 'calc(100vw - 32px)',
    background: '#f9fdf5',
    borderRadius: 16,
    boxShadow: [
      '0 10px 40px rgba(0,0,0,0.13)',
      '0 2px 8px rgba(0,0,0,0.07)',
      'inset 0 1px 0 rgba(255,255,255,0.95)',
    ].join(', '),
    border: '1px solid rgba(122,193,67,0.18)',
    display: 'flex',
    flexDirection: 'column',
    zIndex: 9998,
    overflow: 'visible',
    fontFamily: 'inherit',
  },
  header: {
    background: 'linear-gradient(145deg, #f6fdf0 0%, #eaf6db 60%, #dff2c8 100%)',
    color: '#2d6e1a',
    padding: '13px 16px',
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    fontWeight: 700,
    fontSize: 14.5,
    flexShrink: 0,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    borderBottom: '1px solid rgba(122,193,67,0.18)',
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.9), 0 1px 4px rgba(0,0,0,0.06)',
  },
  headerIcon: { fontSize: 20 },
  closeBtn: {
    marginLeft: 0,
    background: 'none',
    border: 'none',
    color: '#2d6e1a',
    fontSize: 18,
    cursor: 'pointer',
    lineHeight: 1,
    padding: 0,
    opacity: 0.75,
  },
  messages: {
    flex: 1,
    overflowY: 'auto',
    padding: '14px 14px 6px',
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    minHeight: 200,
    background: '#f9fdf5',
  },
  msgUser: {
    alignSelf: 'flex-end',
    background: PRIMARY,
    color: '#fff',
    borderRadius: '14px 14px 4px 14px',
    padding: '8px 13px',
    maxWidth: '80%',
    fontSize: 13.5,
    lineHeight: 1.5,
    wordBreak: 'break-word',
  },
  msgBot: {
    alignSelf: 'flex-start',
    background: '#f4f6f0',
    color: '#222',
    borderRadius: '14px 14px 14px 4px',
    padding: '8px 13px',
    maxWidth: '90%',
    fontSize: 13.5,
    lineHeight: 1.5,
    wordBreak: 'break-word',
  },
  msgTyping: {
    alignSelf: 'flex-start',
    background: '#f4f6f0',
    color: SECONDARY,
    borderRadius: '14px 14px 14px 4px',
    padding: '8px 13px',
    fontSize: 13.5,
    fontStyle: 'italic',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: 12,
    marginTop: 6,
    borderRadius: 6,
    overflow: 'hidden',
  },
  th: {
    background: PRIMARY,
    color: '#fff',
    padding: '5px 8px',
    textAlign: 'left',
    fontWeight: 600,
    whiteSpace: 'nowrap',
  },
  td: {
    padding: '4px 8px',
    borderBottom: '1px solid #eee',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 120,
  },
  trEven: { background: '#f7fbf3' },
  linkBtn: {
    marginTop: 6,
    display: 'inline-block',
    padding: '4px 12px',
    background: PRIMARY,
    color: '#fff',
    borderRadius: 20,
    fontSize: 12,
    cursor: 'pointer',
    border: 'none',
    textDecoration: 'none',
  },
  optionBtns: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 6,
    marginTop: 8,
  },
  optionBtn: {
    padding: '4px 11px',
    background: 'transparent',
    color: PRIMARY,
    border: `1.5px solid ${PRIMARY}`,
    borderRadius: 20,
    fontSize: 12,
    cursor: 'pointer',
    fontFamily: 'inherit',
    transition: 'background 0.15s, color 0.15s',
  },
  footer: {
    display: 'flex',
    gap: 8,
    padding: '10px 12px',
    borderTop: '1px solid rgba(122,193,67,0.15)',
    flexShrink: 0,
    position: 'relative',
    borderBottomLeftRadius: 16,
    borderBottomRightRadius: 16,
    background: 'linear-gradient(145deg, #f6fdf0 0%, #eef8e4 100%)',
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.8)',
  },
  input: {
    flex: 1,
    border: '1px solid rgba(122,193,67,0.3)',
    borderRadius: 24,
    padding: '8px 14px',
    fontSize: 13.5,
    outline: 'none',
    fontFamily: 'inherit',
    background: '#fff',
    boxShadow: 'inset 1px 1px 4px rgba(0,0,0,0.07), inset -1px -1px 2px rgba(255,255,255,0.8)',
    color: '#222',
  },
  suggestionsBox: {
    position: 'absolute',
    bottom: '100%',
    left: 12,
    right: 56,
    background: '#fff',
    border: '1.5px solid #c8dbb8',
    borderRadius: 12,
    boxShadow: '0 4px 18px rgba(0,0,0,0.13)',
    zIndex: 10001,
    maxHeight: 220,
    overflowY: 'auto',
    marginBottom: 4,
  },
  suggestionItem: {
    padding: '9px 14px',
    fontSize: 13,
    cursor: 'pointer',
    color: '#222',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    borderBottom: '1px solid #f0f0f0',
    transition: 'background 0.1s',
  },
  suggestionItemActive: {
    background: '#f4f9ee',
    color: PRIMARY,
  },
  sendBtn: {
    background: 'linear-gradient(145deg, #8fd44a 0%, #6ab52e 100%)',
    color: '#fff',
    border: '1px solid rgba(90,160,30,0.3)',
    borderRadius: '50%',
    width: 36,
    height: 36,
    cursor: 'pointer',
    fontSize: 15,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    boxShadow: '2px 2px 6px rgba(0,0,0,0.15), inset 0 1px 0 rgba(255,255,255,0.3)',
  },
}
